import { createContext,Dispatch } from "react";

type initialStateType = {
    _id:string,
    createModalCourse: boolean,
    deleteModalCourse: boolean,
    createModalUserCourse: boolean
    updateModalCourse: boolean
}

type ModalPartial = {
    state: initialStateType,
    dispatch: Dispatch<any>
}

export const initialState = {
    _id:'',
    createModalCourse: false,
    deleteModalCourse:false,
    createModalUserCourse: false,
    updateModalCourse: false
}

export enum Types {
    CREATE_COURSE = "CREATE_COURSE",
    DELETE_COURSE = "DELETE_COURSE",
    CLEAR_COURSE = "CLEAR_COURSE",
    CREATE_USER_COURSE = "CREATE_USER_COURSE",
    CLOSE_USER_COURSE_MODAL = "CLOSE_USER_COURSE_MODAL",
    UPDATE_COURSE = "UPDATE_COURSE"
}

const ModalInitialState = {
    state: initialState,
    dispatch:() => null
}

const FormacionDesarolloContext = createContext<ModalPartial>(ModalInitialState)

export default FormacionDesarolloContext